import classnames from 'classnames'
import { trackGoogleAnalyticsEvent } from 'common/actions'
import { Tooltip } from 'embed/components/Tooltip'
import { ToggleFieldTrackingEvent } from 'embed/constants'
import Tracker from 'common/services/Tracker'
import { getBooleanFromBooleanString } from 'embed/utils'
import { css } from 'emotion'
import { BooleanOptions, Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'
import { useTheme } from 'embed/hooks'

const Add = require('assets/components/add.svg')
const InfoSmall = require('./info-grey.svg')
const Remove = require('assets/components/remove.svg')
const appStyles = require('embed/styles/application')
const styles = require('./styles')

export interface FormToggleProps {
  onClick: (event: string) => void
  showButtonText: string
  hideButtonText: string
  showFormSection: boolean
  tooltip?: string
  trackingEvent?: ToggleFieldTrackingEvent
}

interface DispatchProps {
  dispatchTrackTrackingEvents: (trackingEvent: ToggleFieldTrackingEvent, formState?: string) => void
}

type Props = FormToggleProps & DispatchProps

const FormSectionToggle: React.FC<Props> = ({
  onClick,
  dispatchTrackTrackingEvents,
  trackingEvent,
  showFormSection,
  tooltip,
  showButtonText,
  hideButtonText,
}) => {
  const toggle = React.useCallback(
    (event: string) => {
      onClick(event)
      if (trackingEvent) {
        const getFormStateForTracking = (): string | undefined =>
          getBooleanFromBooleanString(event) ? trackingEvent?.shown : trackingEvent?.hidden

        const formState: string | undefined = getFormStateForTracking()
        dispatchTrackTrackingEvents(trackingEvent, formState)
      }
    },
    [onClick, getBooleanFromBooleanString, trackingEvent, dispatchTrackTrackingEvents],
  )

  const { colorPrimary, fontFamilyPrimary } = useTheme()
  return (
    <div
      className={classnames(
        styles.applicationFieldToggle,
        appStyles.fullRow,
        css`
          color: ${colorPrimary};
          font-family: ${fontFamilyPrimary};
          svg path {
            fill: ${colorPrimary};
          }
        `,
      )}
    >
      {!showFormSection && (
        <span onClick={toggle.bind(this, BooleanOptions.True)}>
          <Add /> {showButtonText}
        </span>
      )}
      {showFormSection && (
        <span onClick={toggle.bind(this, BooleanOptions.False)}>
          <Remove /> {hideButtonText}
        </span>
      )}
      {tooltip && (
        <Tooltip overlay={tooltip} overlayStyle={{ maxWidth: '300px' }} placement="top" trigger={['hover', 'click']}>
          <span className={styles.infoIcon}>
            <InfoSmall />
          </span>
        </Tooltip>
      )}
    </div>
  )
}

const mapDispatchtoProps = (dispatch): DispatchProps => ({
  dispatchTrackTrackingEvents: (trackingEvent: ToggleFieldTrackingEvent, formState?: string) => {
    dispatch(trackGoogleAnalyticsEvent(trackingEvent.action, undefined, Product.Loan, formState))
    Tracker.trackEvent({
      action: trackingEvent.action.toLowerCase(),
      data: {
        formState,
      },
      timestamp: new Date(),
    })
  },
})

export default connect<null, DispatchProps, FormToggleProps>(null, mapDispatchtoProps)(FormSectionToggle)
